<template>
  <LayoutContent>
    <app-page-title :title="$t('label.hotDeals')"></app-page-title>
    <v-card class="my-6 rounded-lg">
      <v-img :src="hotDealBanner" :max-height="imgHeight"></v-img>
    </v-card>
    <div>
      <v-row>
        <v-col v-for="product in hotDealProduct" :key="product.id" :xs="6" :sm="3" :md="3" :lg="2" :xl="2" :cols="6">
          <item :productInfo="product"></item>
        </v-col>
      </v-row>
    </div>
  </LayoutContent>
</template>

<script>
import { mapGetters } from 'vuex'
import Item from '@/components/product/Item.vue'
import LayoutContent from '../layouts/LayoutContent.vue'
export default {
  name: 'HotDeals',
  components: {
    Item,
    LayoutContent
  },
  computed: {
    ...mapGetters('page', ['landingPageHotDeals']),
    hotDealProduct() {
      return this.$store.state.product.hotDealProduct
    },
    hotDealBanner() {
      return this.landingPageHotDeals ? this.landingPageHotDeals.image_desktop : ''
    },
    imgHeight() {
      return this.$vuetify.breakpoint.smAndUp ? (this.$vuetify.breakpoint.mdAndUp ? '400' : '300') : '150'
    }
  }
}
</script>
